export const uiState = {
    merge: true as true | undefined,
};
